import { createTheme } from '@mui/material/styles';

// const theme = createTheme({
//     // Other theme settings...
//     components: {
//         MuiCssBaseline: {
//             styleOverrides: `
//           @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
//         `,
//         },
//     },
// });
const theme = createTheme({
    components: {
        MuiCssBaseline: {
            styleOverrides: `
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
          `,
        },
    },
    typography: {
        // fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        // fontFamily: ' "Roboto"',
        // fonstFamily: '"-apple-system" '
        fontFamily: `'Sarabun', 'Arial', sans-serif`,
        // fontSize: 14,
        // Customize other typography settings
        // h1: {
        //     fontWeight: 600,
        //     fontSize: '2rem',
        // },
        // h2: {
        //     fontWeight: 600,
        //     fontSize: '1.5rem',
        // },
        // body1: {
        //     fontSize: '0.925rem',
        // },
        // button: {
        //     textTransform: 'none', // Removes all-caps from buttons
        // },
    },
});

export default theme;